/* ══════════════════════════════════════════════════════════════════════════
   CASEMIRA · CONFIGURATEUR DES TAPIS BERBÈRES SUR MESURE        (24/09/2026)
   Snippet : snippets/berbere-configurator.liquid
   ──────────────────────────────────────────────────────────────────────────
   1. Le visiteur saisit largeur et longueur au centimètre (diamètre pour un
      rond). Bornes lues dans la matrice ; au-delà, « contactez-nous », pas de
      prix, bouton désactivé.
   2. Surface = w × l / 10 000 (π r² pour un rond). Variante = la taille
      standard si les deux cotes correspondent exactement (dans un sens ou
      dans l'autre), sinon le premier palier dont la surface couvre la saisie.
   3. Si une taille standard plus grande ou égale dans les deux sens est
      moins chère, on la propose.
   4. Franges (propriété de ligne), sous-couche calculée avec les mêmes tables
      que `assets/casemira-sc-configurator.js`, ajout au panier multi-lignes
      sur la racine de langue (`Shopify.routes.root`, règle Casemira).
   5. Prix du haut de fiche, Klarna et PayPal 4X suivent le prix calculé.
   Aucune chaîne visible en dur : tout vient du bloc JSON des locales.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var root = document.getElementById('berbere-config');
  if (!root) return;

  function lire(sel, repli) {
    var n = root.querySelector(sel);
    if (!n) return repli;
    try { return JSON.parse(n.textContent); } catch (e) { return repli; }
  }
  var M = lire('[data-brb-matrix]', null);
  var V = lire('[data-brb-variants]', {});
  var SCV = lire('[data-brb-sc]', {});
  var S = lire('[data-brb-strings]', {});
  if (!M || !M.standard) return;
  delete V._; delete SCV._;

  var P = (window.FoxTheme && window.FoxTheme.casemira && window.FoxTheme.casemira.panier) || {};
  var RACINE = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CAT = root.getAttribute('data-categorie') || 'tapis';
  var ROND = CAT === 'rond';
  var NOM = root.getAttribute('data-nom') || '';
  var SEM = parseInt(root.getAttribute('data-sem'), 10) || 0;
  var CONTACT = root.getAttribute('data-contact') || (RACINE + 'pages/contact');

  function avec(modele, jetons) {
    var s = String(modele || '');
    Object.keys(jetons).forEach(function (k) { s = s.split('[' + k + ']').join(jetons[k]); });
    return s;
  }
  function esc(t) {
    return String(t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ─── Bornes ─────────────────────────────────────────────────────────── */
  var B = M.bornes || {};
  var BW = B.largeur || (CAT === 'couloir' ? [60, 120] : [100, 400]);
  var BL = B.longueur || (CAT === 'couloir' ? [150, 600] : [150, 600]);
  var BD = B.diametre || [100, 300];
  var MAXTXT = ROND ? 'Ø ' + BD[1] : BW[1] + ' × ' + BL[1];

  /* ─── Données : standards et paliers, rattachés aux variantes réelles ── */
  function cellule(o) {
    var v = V[o.sku];
    return {
      sku: o.sku,
      w: Number(o.w) || 0, l: Number(o.l) || 0, d: Number(o.d) || 0,
      m2: Number(o.m2) || 0,
      id: v ? v.id : null,
      ok: !!(v && v.a === 1),
      p: v ? v.p : Math.round(Number(o.prix || 0) * 100)
    };
  }
  var STD = (M.standard || []).map(cellule);
  var PAL = (M.paliers || []).map(cellule).sort(function (a, b) { return a.m2 - b.m2; });

  /* ─── Mise en forme ─────────────────────────────────────────────────── */
  function prixLocalise(cents) {
    if (!window.FoxTheme || !FoxTheme.Currency || !FoxTheme.Currency.formatMoney) return null;
    var PR = (FoxTheme.casemira && FoxTheme.casemira.prix) || {};
    var sansZeros = cents % 100 === 0;
    var fmt = sansZeros ? PR.format_sans_zeros : PR.format;
    if (!fmt) {
      fmt = (FoxTheme.settings && FoxTheme.settings.moneyFormat) || '';
      if (fmt && sansZeros) {
        fmt = fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, '{{amount_no_decimals_with_comma_separator}}')
                 .replace(/\{\{\s*amount\s*\}\}/, '{{amount_no_decimals}}');
      }
    }
    if (!fmt) return null;
    try { return FoxTheme.Currency.formatMoney(cents, fmt); } catch (e) { return null; }
  }
  function prix(cents) {
    var l = prixLocalise(Math.round(cents));
    if (l !== null) return l;
    var cur = 'EUR';
    try { if (window.Shopify && Shopify.currency && Shopify.currency.active) cur = Shopify.currency.active; } catch (e) {}
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency', currency: cur, minimumFractionDigits: 0,
        maximumFractionDigits: cents % 100 === 0 ? 0 : 2
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(0) + ' €'; }
  }
  /* Même formule que `casemira-pdp-klarna.liquid` pour les mensualités. */
  function mensualite(c) {
    var cur = 'EUR';
    try { if (window.Shopify && Shopify.currency && Shopify.currency.active) cur = Shopify.currency.active; } catch (e) {}
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency', currency: cur, minimumFractionDigits: 0,
        maximumFractionDigits: c % 100 === 0 ? 0 : 2
      }).format(c / 100);
    } catch (e) { return String(Math.round(c / 100)); }
  }
  function m2Txt(x) {
    var s = (Math.round(x * 100) / 100).toString();
    var lang = (document.documentElement.lang || 'fr').slice(0, 2);
    return lang === 'en' ? s : s.replace('.', ',');
  }
  function dimTxt(c) {
    return c.d ? 'Ø ' + c.d + ' cm' : c.w + ' x ' + c.l + ' cm';
  }

  /* ─── DOM ───────────────────────────────────────────────────────────── */
  var inW = document.getElementById('brb-w');
  var inL = document.getElementById('brb-l');
  var inD = document.getElementById('brb-d');
  var elBornes = document.getElementById('brb-bornes');
  var elStd = document.getElementById('brb-std');
  var elPrix = document.getElementById('brb-prix');
  var elType = document.getElementById('brb-type');
  var elFab = document.getElementById('brb-fab');
  var elSug = document.getElementById('brb-suggest');
  var elSugTxt = document.getElementById('brb-suggest-txt');
  var elSugBtn = document.getElementById('brb-suggest-btn');
  var elMsg = document.getElementById('brb-msg');
  var scWrap = document.getElementById('brb-sc-wrap');
  var scBox = document.getElementById('brb-sc');
  var scPrix = document.getElementById('brb-sc-prix');
  var scDetail = document.getElementById('brb-sc-detail');
  var btn = document.getElementById('brb-atc');
  var btnMontant = document.getElementById('brb-atc-montant');
  var btnPrix = document.getElementById('brb-atc-prix');
  var elErr = document.getElementById('brb-erreur');

  elBornes.textContent = ROND
    ? avec(S.bornesRond, { min: BD[0], max: BD[1] })
    : avec(S.bornes, { wmin: BW[0], wmax: BW[1], lmin: BL[0], lmax: BL[1] });

  /* Le prix fixe du haut de fiche devient le prix vivant. */
  var hautPrix = document.querySelector('.product__block--price .f-price__regular .f-price-item--regular');
  var hautPrixDepart = hautPrix ? hautPrix.innerHTML : '';

  /* ─── Raccourcis : tailles standard ─────────────────────────────────── */
  STD.forEach(function (c) {
    if (!c.id) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'couloir-calc__width-btn';
    b.setAttribute('data-sku', c.sku);
    b.setAttribute('aria-pressed', 'false');
    b.innerHTML = '<span class="couloir-calc__width-value">' + (c.d ? 'Ø ' + c.d : c.w + ' × ' + c.l) + '</span><span class="couloir-calc__width-unit">cm</span>';
    if (!c.ok) b.disabled = true;
    b.addEventListener('click', function () { poser(c); });
    elStd.appendChild(b);
  });

  function poser(c) {
    if (ROND) { inD.value = c.d; } else { inW.value = c.w; inL.value = c.l; }
    calcule();
  }

  /* ─── Lecture de la saisie ──────────────────────────────────────────── */
  function nombre(inp) {
    if (!inp) return null;
    var t = String(inp.value || '').replace(',', '.').replace(/[^\d.]/g, '');
    if (!t) return null;
    var n = Math.round(parseFloat(t));
    return isFinite(n) && n > 0 ? n : null;
  }

  /* ─── Sous-couche : tables copiées de assets/casemira-sc-configurator.js ─
     À garder alignées avec ce fichier (et generate_metafields.py). */
  var RECT_RULES = {
    '40x60': ['SC-40x60', 'aucune'], '50x80': ['SC-50x80', 'aucune'],
    '60x100': ['SC-70x200', 'decoupe'], '70x140': ['SC-70x200', 'decoupe'],
    '80x150': ['SC-90x200', 'decoupe'], '80x300': ['SC-90x200,SC-90x200', 'multi'],
    '90x150': ['SC-90x200', 'decoupe'], '90x310': ['SC-90x200,SC-90x200', 'multi'],
    '100x150': ['SC-120x200', 'decoupe'], '100x190': ['SC-120x200', 'decoupe'],
    '100x200': ['SC-120x200', 'decoupe'], '120x170': ['SC-120x200', 'decoupe'],
    '120x180': ['SC-120x200', 'decoupe'], '150x200': ['SC-150x200', 'aucune'],
    '150x210': ['SC-150x200', 'decoupe'], '150x230': ['SC-150x200', 'decoupe'],
    '150x300': ['SC-150x200,SC-150x200', 'multi'], '160x200': ['SC-180x200', 'decoupe'],
    '160x220': ['SC-180x200', 'decoupe'], '160x230': ['SC-180x200', 'decoupe'],
    '180x250': ['SC-300x200', 'decoupe'], '180x270': ['SC-300x200', 'decoupe'],
    '180x280': ['SC-300x200', 'decoupe'], '200x200': ['SC-200x200', 'aucune'],
    '200x240': ['SC-300x200', 'decoupe'], '200x290': ['SC-300x200', 'decoupe'],
    '200x300': ['SC-300x200', 'aucune'], '200x400': ['SC-200x200,SC-200x200', 'multi'],
    '240x330': ['SC-300x200,SC-300x200', 'multi'], '250x350': ['SC-300x200,SC-300x200', 'multi'],
    '280x380': ['SC-300x200,SC-300x200', 'multi'], '300x400': ['SC-300x200,SC-300x200', 'multi'],
    '400x400': ['SC-200x200,SC-200x200,SC-200x200,SC-200x200', 'grille']
  };
  var ROND_RULES = {
    50: ['SC-50x50', 'cercle'], 60: ['SC-70x200', 'cercle'], 80: ['SC-90x200', 'cercle'],
    100: ['SC-120x200', 'cercle'], 120: ['SC-120x200', 'cercle'], 140: ['SC-150x200', 'cercle'],
    160: ['SC-180x200', 'cercle'], 200: ['SC-200x200', 'cercle'],
    250: ['SC-300x200,SC-300x200', 'multi-cercle'], 300: ['SC-300x200,SC-300x200', 'multi-cercle'],
    400: ['SC-200x200,SC-200x200,SC-200x200,SC-200x200', 'grille-cercle']
  };
  var SC_DIMS = [
    ['SC-40x40', 40, 40], ['SC-40x60', 40, 60], ['SC-50x50', 50, 50], ['SC-50x80', 50, 80],
    ['SC-70x200', 70, 200], ['SC-90x200', 90, 200], ['SC-120x200', 120, 200],
    ['SC-150x200', 150, 200], ['SC-180x200', 180, 200], ['SC-200x200', 200, 200],
    ['SC-220x200', 200, 220], ['SC-300x200', 200, 300]
  ];
  function scPrixDe(sku) { return SCV[sku] ? SCV[sku].p : 0; }
  function couvre(A, Bb, a, b) { return (A >= a && Bb >= b) || (A >= b && Bb >= a); }
  function uniqueMoinsCher(a, b) {
    var best = null;
    SC_DIMS.forEach(function (d) {
      if (!couvre(d[1], d[2], a, b)) return;
      var p = scPrixDe(d[0]);
      if (!p) return;
      if (!best || p < best.p) best = { skus: [d[0]], p: p, exact: (d[1] === a && d[2] === b) || (d[1] === b && d[2] === a) };
    });
    return best;
  }
  function multiMoinsCher(a, b) {
    var best = null;
    SC_DIMS.forEach(function (d) {
      [[d[1], d[2]], [d[2], d[1]]].forEach(function (o) {
        if (o[0] < a) return;
        var nb = Math.ceil(b / o[1]);
        if (nb < 2) return;
        var p = scPrixDe(d[0]) * nb;
        if (!p) return;
        if (!best || p < best.p) {
          var l = []; for (var i = 0; i < nb; i++) l.push(d[0]);
          best = { skus: l, p: p };
        }
      });
    });
    return best;
  }
  function regle(skus, action) {
    var l = skus.split(',');
    for (var i = 0; i < l.length; i++) if (!SCV[l[i]]) return null;
    return { skus: l, action: action };
  }
  function scRect(w, l) {
    var a = Math.min(w, l), b = Math.max(w, l);
    var r = RECT_RULES[a + 'x' + b];
    if (r) { var x = regle(r[0], r[1]); if (x) return x; }
    /* Écart assumé avec casemira-sc-configurator.js : un panneau unique qui couvre
       le tapis passe toujours avant plusieurs bandes (163 x 228 donnait 4 x 70 x 200
       pour 30 centimes de moins que le 200 x 300). */
    var s = uniqueMoinsCher(a, b), m = s ? null : multiMoinsCher(a, b);
    if (s) return { skus: s.skus, action: s.exact ? 'aucune' : 'decoupe' };
    if (m) return { skus: m.skus, action: 'multi' };
    return null;
  }
  function scRond(d) {
    var r = ROND_RULES[d];
    if (r) { var x = regle(r[0], r[1]); if (x) return x; }
    var s = uniqueMoinsCher(d, d), m = s ? null : multiMoinsCher(d, d);
    if (s) return { skus: s.skus, action: 'cercle' };
    if (m) return { skus: m.skus, action: 'multi-cercle' };
    return null;
  }
  function scCouloir(w, lCm) {
    var sku = w <= 70 ? 'SC-70x200' : w <= 90 ? 'SC-90x200' : w <= 120 ? 'SC-120x200'
            : w <= 150 ? 'SC-150x200' : w <= 180 ? 'SC-180x200' : w <= 200 ? 'SC-200x200' : null;
    if (!sku || !SCV[sku]) return null;
    var nb = Math.ceil(lCm / 200), l = [];
    for (var i = 0; i < nb; i++) l.push(sku);
    return { skus: l, action: nb === 1 ? 'decoupe' : 'multi' };
  }
  function scNote(action, n) {
    if (n === 1) {
      if (action === 'aucune') return '';
      if (action === 'cercle') return P.scNoteCercle || 'À découper en cercle';
      return P.scNoteCiseaux || 'À ajuster aux ciseaux';
    }
    if (action === 'multi-cercle') return avec(P.scNoteCercleN || '[n] sous-couches à poser côte à côte puis à découper en cercle', { n: n });
    if (action === 'grille' || action === 'grille-cercle') return avec(P.scNoteCarreN || '[n] sous-couches à poser en carré', { n: n });
    return avec(P.scNoteCoteN || '[n] sous-couches à poser côte à côte', { n: n });
  }
  function scResume(skus) {
    var n = {};
    skus.forEach(function (s) { n[s] = (n[s] || 0) + 1; });
    return Object.keys(n).map(function (s) {
      var d = (SCV[s] && SCV[s].dim) || s;
      return n[s] === 1 ? d : n[s] + ' × ' + d;
    }).join(' + ');
  }
  var AVEC_SC = Object.keys(SCV).length > 0;

  /* ─── Paiement fractionné : même logique que casemira-pdp-klarna.liquid ─ */
  var kl = document.getElementById('casemira-klarna-line');
  function paiement(cents) {
    if (!kl) return;
    var min = parseInt(kl.getAttribute('data-klarna-min-cents'), 10) || 3500;
    var max = parseInt(kl.getAttribute('data-klarna-max-cents'), 10) || 300000;
    var pf = kl.getAttribute('data-cm-pf') === '1';
    var seul = pf ? (kl.parentNode || document).querySelector('[data-cm-pf-seul]') : null;
    var ppMin = parseInt(kl.getAttribute('data-pp-min-cents'), 10) || 0;
    var ppMax = parseInt(kl.getAttribute('data-pp-max-cents'), 10) || 0;
    var elK = document.getElementById('casemira-klarna-installment');
    var elP = pf ? kl.querySelector('[data-cm-pf-p]') : null;
    var elP2 = seul ? seul.querySelector('[data-cm-pf-p]') : null;
    if (!cents) { kl.style.display = 'none'; if (seul) seul.style.display = 'none'; return; }
    var okK = cents >= min && cents <= max, okP = pf && cents >= ppMin && cents <= ppMax;
    if (!pf) {
      if (!okK) { kl.style.display = 'none'; return; }
      kl.style.display = ''; if (elK) elK.textContent = mensualite(Math.ceil(cents / 3));
      return;
    }
    if (okK && okP) {
      kl.style.display = ''; if (seul) seul.style.display = 'none';
      if (elK) elK.textContent = mensualite(Math.ceil(cents / 3));
      if (elP) elP.textContent = mensualite(Math.ceil(cents / 4));
    } else if (okP) {
      kl.style.display = 'none';
      if (seul) { seul.style.display = ''; if (elP2) elP2.textContent = mensualite(Math.ceil(cents / 4)); }
    } else {
      kl.style.display = 'none'; if (seul) seul.style.display = 'none';
    }
  }

  /* ─── Calcul ────────────────────────────────────────────────────────── */
  var etat = null; /* { cell, dims:{w,l,d}, surface, standard:bool, sc } */

  function trouve() {
    var w, l, d, surface;
    if (ROND) {
      d = nombre(inD);
      if (!d) return { vide: true };
      if (d < BD[0]) return { sous: true };
      if (d > BD[1]) return { hors: true };
      surface = Math.PI * Math.pow(d / 2, 2) / 10000;
      for (var i = 0; i < STD.length; i++) if (STD[i].d && STD[i].d === d) return { cell: STD[i], dims: { d: d }, surface: surface, standard: true };
    } else {
      w = nombre(inW); l = nombre(inL);
      if (!w || !l) return { vide: true };
      if (w < BW[0] || l < BL[0]) return { sous: true };
      if (w > BW[1] || l > BL[1]) return { hors: true };
      surface = w * l / 10000;
      for (var j = 0; j < STD.length; j++) {
        var s = STD[j];
        if ((s.w === w && s.l === l) || (s.w === l && s.l === w)) return { cell: s, dims: { w: w, l: l }, surface: surface, standard: true };
      }
    }
    for (var k = 0; k < PAL.length; k++) {
      if (PAL[k].m2 + 1e-9 >= surface) return { cell: PAL[k], dims: ROND ? { d: d } : { w: w, l: l }, surface: surface, standard: false };
    }
    return { hors: true };
  }

  function suggestion(r) {
    if (!r.cell || r.standard) return null;
    var best = null;
    STD.forEach(function (s) {
      if (!s.ok || s.p >= r.cell.p) return;
      var couvreIci = ROND
        ? s.d && s.d >= r.dims.d
        : s.w && couvre(s.w, s.l, r.dims.w, r.dims.l);
      if (couvreIci && (!best || s.p < best.p)) best = s;
    });
    return best;
  }

  /* « Sur mesure : 163 × 228 cm » à droite du prix, même nœud que « Format : »
     des fiches fait main (`.cm-price-format`, casemira-pdp-reskin.js). */
  var prixConteneur = document.querySelector('.section-main-product .product__block--price [id^="price-"]');
  function formatHaut(dims) {
    if (!prixConteneur) return;
    var f = prixConteneur.querySelector('.cm-price-format');
    if (!dims) { if (f) f.innerHTML = ''; return; }
    if (!f) { f = document.createElement('span'); f.className = 'cm-price-format'; prixConteneur.appendChild(f); }
    var t = (dims.d ? 'Ø ' + dims.d : dims.w + ' × ' + dims.l) + ' cm';
    var html = avec(S.formatLabel || 'Sur mesure : [t]', { t: '<strong>' + esc(t) + '</strong>' });
    if (f.innerHTML !== html) f.innerHTML = html;
  }
  /* Paiement express (PayPal) : même mécanisme que couloir-calc__buynow. */
  var buyWrap = document.getElementById('brb-buynow');
  var buyId = document.getElementById('brb-buynow-id');
  function syncExpress(c, props) {
    if (!buyWrap || !buyId) return;
    if (!c) { buyWrap.hidden = true; return; }
    buyWrap.hidden = false;
    root.querySelectorAll('[data-brb-prop]').forEach(function (inp) {
      inp.value = props[inp.getAttribute('data-brb-prop')] || '';
    });
    if (buyId.value !== String(c.id)) {
      buyId.value = c.id;
      buyId.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  function afficherPrix(cents) {
    var t = cents ? prix(cents) : '';
    elPrix.textContent = t;
    /* Hors bornes, le haut de fiche ne montre aucun montant plutôt qu'un prix faux. */
    if (hautPrix) { if (t) { hautPrix.textContent = t; hautPrix.style.visibility = ''; } else { hautPrix.innerHTML = hautPrixDepart; hautPrix.style.visibility = 'hidden'; } }
    if (cents) { btnPrix.textContent = t; btnMontant.hidden = false; }
    else { btnMontant.hidden = true; }
    paiement(cents);
    /* la ligne Klarna du thème se recalcule 60 ms après un `change` sur
       name="id" avec le prix de la seule variante : on repasse derrière. */
    setTimeout(function () { paiement(cents); }, 120);
  }

  function marquerStd(sku) {
    elStd.querySelectorAll('.couloir-calc__width-btn').forEach(function (b) {
      var on = b.getAttribute('data-sku') === sku;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  /* ─── État exposé au tiroir « Guide des tailles » (25/09) ──────────────
     Même contrat que le picker couloir (`casemira-guide-tiroir.liquid` § 8.1) :
     `data-cm-largeur` en cm (entier), `data-cm-longueur` en mètres à deux
     décimales, plus `data-cm-diametre` en cm pour un rond, et `data-cm-dispo`.
     Écrit à CHAQUE calcul, saisie hors bornes comprise (le tiroir montre ce qui
     est tapé), puis `berbere:change` réveille le tiroir s'il est ouvert. */
  function expose(ok) {
    var w = nombre(inW), l = nombre(inL), d = nombre(inD);
    if (ROND) {
      root.setAttribute('data-cm-diametre', d ? String(d) : '');
      root.setAttribute('data-cm-largeur', d ? String(d) : '');
      root.setAttribute('data-cm-longueur', d ? (d / 100).toFixed(2) : '');
    } else {
      root.setAttribute('data-cm-largeur', w ? String(w) : '');
      root.setAttribute('data-cm-longueur', l ? (l / 100).toFixed(2) : '');
    }
    root.setAttribute('data-cm-dispo', ok ? '1' : '0');
  }

  function calcule() {
    var r = trouve();
    expose(!!(r.cell && r.cell.ok && r.cell.id));
    elErr.hidden = true;
    elSug.hidden = true;
    elMsg.hidden = true;
    elBornes.classList.remove('is-alerte');
    etat = null;

    if (!r.cell) {
      marquerStd(null);
      elType.textContent = '';
      elFab.textContent = '';
      afficherPrix(0);
      formatHaut(null);
      syncExpress(null);
      btn.disabled = true;
      scWrap.hidden = true;
      if (r.hors) {
        elMsg.innerHTML = avec(S.horsBornes, { contact: esc(CONTACT), max: MAXTXT });
        elMsg.hidden = false;
      } else if (r.sous) {
        elBornes.classList.add('is-alerte');
      }
      document.dispatchEvent(new CustomEvent('berbere:change', { detail: { dims: null } }));
      return;
    }

    var c = r.cell;
    var fab = ROND ? { d: r.dims.d } : { w: r.dims.w, l: r.dims.l };
    marquerStd(r.standard ? c.sku : null);
    elType.textContent = r.standard ? (S.tailleStandard || '') : avec(S.surMesure, { m2: m2Txt(c.m2) });
    elFab.textContent = avec(S.fabriquees, { dim: dimTxt(fab) });

    if (!c.ok || !c.id) {
      afficherPrix(0);
      syncExpress(null);
      elPrix.textContent = S.indisponible || '';
      btn.disabled = true;
      scWrap.hidden = true;
      elMsg.innerHTML = avec(S.horsBornes, { contact: esc(CONTACT), max: MAXTXT });
      elMsg.hidden = false;
      document.dispatchEvent(new CustomEvent('berbere:change', { detail: { dims: null } }));
      return;
    }

    var sug = suggestion(r);
    if (sug) {
      elSugTxt.textContent = avec(S.moinsCher, { dim: dimTxt(sug), prix: prix(sug.p) });
      elSug.hidden = false;
      elSugBtn.onclick = function () { poser(sug); };
    }

    /* Sous-couche */
    var sc = null;
    if (AVEC_SC) {
      sc = ROND ? scRond(fab.d) : CAT === 'couloir' ? scCouloir(fab.w, fab.l) : scRect(fab.w, fab.l);
      scWrap.hidden = false;
      if (sc) {
        sc.p = sc.skus.reduce(function (t, s) { return t + scPrixDe(s); }, 0);
        scPrix.textContent = '(+ ' + prix(sc.p) + ')';
        var note = scNote(sc.action, sc.skus.length);
        scDetail.textContent = avec(S.scDetail, { dim: scResume(sc.skus) }) + (note ? ' · ' + note : '');
        scBox.disabled = false;
      } else {
        scPrix.textContent = '';
        scDetail.textContent = S.scIndispo || '';
        scBox.checked = false;
        scBox.disabled = true;
      }
    }

    etat = { cell: c, dims: fab, standard: r.standard, sc: sc };
    var pe = proprietes(c, fab);
    syncExpress(c, pe);
    var total = c.p + (sc && scBox.checked ? sc.p : 0);
    afficherPrix(total);
    formatHaut(fab);
    btn.disabled = false;

    root.setAttribute('data-brb-sku', c.sku);
    document.dispatchEvent(new CustomEvent('berbere:change', {
      detail: { sku: c.sku, variantId: c.id, price: c.p, dims: fab, standard: r.standard }
    }));
  }

  [inW, inL, inD].forEach(function (inp) {
    if (!inp) return;
    inp.addEventListener('input', function () {
      var t = inp.value.replace(/[^\d]/g, '').slice(0, 4);
      if (t !== inp.value) inp.value = t;
      calcule();
    });
    inp.addEventListener('focus', function () { try { inp.select(); } catch (e) {} });
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); inp.blur(); } });
  });
  if (scBox) scBox.addEventListener('change', calcule);

  /* Boutons − et + (1 cm), appui long qui défile, comme le calculateur couloir. */
  var tenue = null, repete = null;
  function pas(b) {
    var inp = document.getElementById(b.getAttribute('data-brb-cible'));
    if (!inp) return;
    var n = nombre(inp) || 0;
    inp.value = Math.max(0, n + parseInt(b.getAttribute('data-brb-pas'), 10));
    calcule();
  }
  function stop() { clearTimeout(tenue); clearInterval(repete); tenue = repete = null; }
  root.querySelectorAll('[data-brb-pas]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); pas(b); });
    b.addEventListener('pointerdown', function () { stop(); tenue = setTimeout(function () { repete = setInterval(function () { pas(b); }, 70); }, 380); });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { b.addEventListener(ev, stop); });
  });

  /* 09/10/2026 13h09 : « Modèle » devient `_Modèle` (préfixe souligné = caché par
     casemira-cart-ligne.liquid, casemira-cart.js surMesureDe et le paiement) : le client ne
     voit plus le SKU, la commande le porte déjà. Décision Raphaël. */
  function proprietes(c, dims) {
    var fr = frangesChoisies();
    if (ROND) return { 'Dimensions': dimTxt(dims), '_Modèle': NOM + ' (' + c.sku + ')' }; /* 25/09 : pas de franges sur un rond */
    return { 'Dimensions': dimTxt(dims), 'Franges': fr.label, '_Modèle': NOM + ' (' + c.sku + ')', '_franges': fr.code };
  }

  /* ─── Ajout au panier ───────────────────────────────────────────────── */
  root.querySelectorAll('[data-franges]').forEach(function (b) {
    b.addEventListener('click', function () {
      root.querySelectorAll('[data-franges]').forEach(function (x) {
        var on = x === b;
        x.classList.toggle('forme-option--active', on);
        x.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      calcule();
    });
  });
  function frangesChoisies() {
    var r = root.querySelector('[data-franges].forme-option--active');
    var v = r ? r.getAttribute('data-franges') : 'deux-cotes';
    var lbl = v === 'sans' ? S.frangesSans : v === 'un-cote' ? S.frangesUn : S.frangesDeux;
    return { code: v, label: lbl || v };
  }

  btn.addEventListener('click', function () {
    if (btn.disabled || !etat || btn.classList.contains('btn--loading')) return;
    var c = etat.cell;
    var props = proprietes(c, etat.dims);
    if (SEM > 0) props._sur_commande = String(SEM);
    /* 14/10/2026 : pictogrammes de la fiche en propriété cachée, pour le mail de
       confirmation (snippets/casemira-proprietes-ligne.liquid ; pas de date sur commande). */
    var cachees = window.CasemiraDelivery && window.CasemiraDelivery.lineProperties ? window.CasemiraDelivery.lineProperties(root) : {};
    Object.keys(cachees).forEach(function (k) { props[k] = cachees[k]; });
    var items = [{ id: c.id, quantity: 1, properties: props }];
    if (etat.sc && scBox && scBox.checked) {
      var n = {};
      etat.sc.skus.forEach(function (s) { n[s] = (n[s] || 0) + 1; });
      Object.keys(n).forEach(function (s) {
        items.push({ id: SCV[s].id, quantity: n[s], properties: { '_Pour le tapis': c.sku } });
      });
    }
    btn.classList.add('btn--loading');
    fetch(RACINE + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'cart'); });
        return r.json();
      })
      .then(function () { return fetch(RACINE + 'cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count-bubble span, [data-cart-count], .cart-count, .js-cart-count, .header__cart-count')
          .forEach(function (el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true, cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        document.dispatchEvent(new CustomEvent('cart:change', { detail: cart }));
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.show === 'function') cd.show();
        setTimeout(function () { btn.classList.remove('btn--loading'); }, 600);
      })
      .catch(function (err) {
        if (window.console) console.error('[Berbère]', err);
        btn.classList.remove('btn--loading');
        elErr.textContent = S.erreur || '';
        elErr.hidden = false;
      });
  });

  /* ─── Départ : ?variant= d'une taille standard, sinon la taille phare ── */
  function depart() {
    var q = null;
    try { q = new URLSearchParams(location.search).get('variant'); } catch (e) {}
    var i, c;
    if (q) {
      for (i = 0; i < STD.length; i++) if (String(STD[i].id) === q && STD[i].ok) return STD[i];
    }
    var phare = ROND ? 'd200' : CAT === 'couloir' ? '80x250' : '160x230';
    for (i = 0; i < STD.length; i++) {
      c = STD[i];
      if (!c.ok) continue;
      if ((ROND && 'd' + c.d === phare) || (!ROND && c.w + 'x' + c.l === phare)) return c;
    }
    for (i = 0; i < STD.length; i++) if (STD[i].ok) return STD[i];
    return null;
  }
  /* ─── Sens inverse : le tiroir pose des dimensions (25/09) ─────────────
     Contrat du picker couloir : `couloir:set-dimensions` avec `width` (cm) et
     `length` (mètres) ; `diameter` (cm) pour un rond. Chaque valeur est
     arrondie au centimètre et ramenée dans les bornes de la matrice, puis le
     calcul habituel repart (prix, variante, `berbere:change`). Le tiroir relit
     ensuite l'état exposé pour dire ce qui a réellement été retenu. */
  function borne(v, b) { return Math.min(b[1], Math.max(b[0], Math.round(v))); }
  document.addEventListener('couloir:set-dimensions', function (e) {
    var dt = (e && e.detail) || {};
    if (ROND) {
      var dd = Number(dt.diameter);
      if (!isFinite(dd) || dd <= 0) return;
      inD.value = borne(dd, BD);
    } else {
      var w = Number(dt.width), l = Number(dt.length) * 100;
      if (isFinite(w) && w > 0) inW.value = borne(w, BW);
      if (isFinite(l) && l > 0) inL.value = borne(l, BL);
    }
    calcule();
  });

  var d0 = depart();
  if (d0) poser(d0); else calcule();
  root.classList.add('is-pret');
})();
